import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { Button } from '../../button/button';

export const SubmitButton = ({ children, startIcon, endIcon, ...rest }) => {
    const { handleSubmit, formState } = useFormContext();
    const isLoading = formState.isSubmitting;

    const handleClick = () => {
        if (rest.type !== 'button') return;
        handleSubmit();
    };

    return (
        <Button
            type='submit'
            startIcon={isLoading ? null : startIcon}
            endIcon={isLoading ? null : endIcon}
            onClick={handleClick}
            loading={isLoading}
            {...rest}
        >
            {children}
        </Button>
    );
};

SubmitButton.propTypes = {
    children: PropTypes.string,
    startIcon: PropTypes.object,
    endIcon: PropTypes.object
};
